import {useQuery} from 'react-query';

import getBuyersList from '.';

const useGetBuyersList = (payload: IBuyerParams) => {
  const {data, isLoading} = useQuery(['get-buyers-list', payload], () =>
    getBuyersList(payload),
  );

  return {buyersList: data, buyersListIsLoading: isLoading};
};

export default useGetBuyersList;
